export default __webpack_public_path__ + "static/media/ConfirmedImage.2c5bd28e.svg";